// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"2ea6df72","930":"29384856"}[chunkId] + ".chunk.css";
};